
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.558 1.102C3.008.212 1.75.94 1.75 2.728v13.19c0 1.789 1.257 2.517 2.808 1.628l11.528-6.611c1.552-.89 1.552-2.332 0-3.222L4.558 1.102z","fill":"#748190"}})])
          )
        }
      }
    